import React from 'react';
import { Globe, Twitter, Send } from 'lucide-react';

/**
 * Componente para mostrar enlaces sociales de un productor
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.website] - URL del sitio web del productor
 * @param {string} [props.twitter] - Nombre de usuario de Twitter del productor
 * @param {string} [props.telegram] - Nombre de usuario de Telegram del productor
 * @returns {JSX.Element|null} - Componente de enlaces o null si no hay enlaces
 */
const ProducerLinks = ({ website: rawWebsite, twitter, telegram }) => {
  // El website viene de datos on-chain: solo enlazar http(s)
  const website = /^https?:\/\//i.test(rawWebsite || '') ? rawWebsite : null;
  if (!website && !twitter && !telegram) return null;

  return (
    <div className="flex space-x-3">
      {website && (
        <a
          href={website}
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 hover:text-green-700 transition-colors duration-200"
          title="Website"
        >
          <Globe size={16} />
        </a>
      )}
      {twitter && (
        <a
          href={`https://twitter.com/${twitter}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-400 hover:text-indigo-500 transition-colors duration-200"
          title="Twitter"
        >
          <Twitter size={16} />
        </a>
      )}
      {telegram && (
        <a
          href={`https://t.me/${telegram}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-500 hover:text-indigo-700 transition-colors duration-200"
          title="Telegram"
        >
          <Send size={16} />
        </a>
      )}
    </div>
  );
};

export default React.memo(ProducerLinks);
